export class DbSelectLookUpModel {
    databaseSelectId?: string;
    databaseSelectValueId?: string;
    name: string;
    values: DbSelectLookUpValue[];
    active?: boolean;
    parentId: string;
    hasItems: boolean;
}

export class DbSelectLookUpValue {
    databaseSelectValueId?: string;
    name: string;
    active?: boolean;
}
